import { Stack, Typography, Dialog, IconButton, Avatar } from '@mui/material';
import { getRecommendations, IRecommendations } from 'API/Home/recommendations';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { useCallback, useEffect, useState } from 'react';
import { RecommendationCard } from './RecommendationCard';
import { MedicationList } from './RecommendationCard/RecoomendationInformation/MedicationList';
import { PurpleClose } from 'Images';

const MAX_RECOMMENDATIONS_VIEW = 3;

export const Recommendations = () => {
  const [recommendations, setRecommendations] = useState<IRecommendations[]>(
    []
  );
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [selectedRecommendation, setSelectedRecommendation] =
    useState<IRecommendations | null>(null);

  const handleOpenDialog = (recommendation: IRecommendations) => {
    setSelectedRecommendation(recommendation);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedRecommendation(null);
  };

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Home
  ).userRecommendations;
  const isDesktop = useIsDesktop();

  const initRecommendations = useCallback(async () => {
    const recommendations = await getRecommendations();
    if (recommendations) {
      recommendations.forEach(
        (recommendation: IRecommendations, index: number) =>
          (recommendation.identifier = index)
      );
      setRecommendations(recommendations);
    }
  }, []);

  useEffect(() => {
    initRecommendations();
  }, [initRecommendations, imposterId]);

  const removeRecommendation = (id: number) => {
    const updatedRecommendations = recommendations.filter(
      (recommendation) => recommendation.identifier !== id
    );
    setRecommendations(updatedRecommendations);
  };

  if (recommendations.length === 0) return null;

  return (
    <Stack>
      <Typography variant='h5' component={'h2'}>
        {dictionary.title}
      </Typography>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap='24px'
        flexWrap='wrap'
        sx={{
          m: '12px 0',
        }}
      >
        {recommendations.map(
          (recommendationItem: IRecommendations, index: number) => {
            if (index >= MAX_RECOMMENDATIONS_VIEW) return null;

            const hasMedicationList =
              recommendationItem.entityJSON?.items?.some(
                (item) => item.medicationName || item.medicationCode
              );

            let isHaveMedicationList = false;
            const title = recommendationItem.entityJSON.title;
            if (title === dictionary.openList) {
              isHaveMedicationList = true;
            }

            return (
              <RecommendationCard
                key={index}
                recommendationItem={recommendationItem}
                removeRecommendation={removeRecommendation}
                setShowDialog={
                  hasMedicationList
                    ? () => handleOpenDialog(recommendationItem)
                    : undefined
                }
              />
            );
          }
        )}
      </Stack>
      <Dialog
        open={showDialog}
        onClose={handleCloseDialog}
        maxWidth='md'
        fullWidth
      >
        <IconButton
          onClick={handleCloseDialog}
          sx={{
            position: 'absolute',
            right: isDesktop ? '8px' : '13px',
            top: isDesktop ? '12px' : '13px',
          }}
        >
          <Avatar
            alt={dictionary.close}
            src={PurpleClose}
            sx={{
              width: isDesktop ? '42px' : '34px',
              height: isDesktop ? '42px' : '34px',
            }}
          />
        </IconButton>
        {selectedRecommendation && (
          <MedicationList data={selectedRecommendation} />
        )}
      </Dialog>
    </Stack>
  );
};
